import controller from './app-controller';
import template from './app.html'

const AppComponent = {
    controller,
    template
};

export default AppComponent;



// WEBPACK FOOTER //
// ./app/app-component.js